import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import icon_up from '../../../../i/up.svg'
import icon_down from '../../../../i/down.svg'
import icon_clone from '../../../../i/clone.svg'
import icon_delete from '../../../../i/delete.svg'
import icon_locked from '../../../../i/locked.svg'

import styles from './Inline.module.scss'

const InlineControls = ({
    onAction,
    blockId,
    firstElement,
    lastElement,
    isVisible,
    isHideClone,
    isHideDelete,
    inlineControlsRef,
}) => {
    const { t } = useTranslation()
    const onClick = action => {
        onAction({ action, blockId })
    }

    return (
        <ul
            ref={inlineControlsRef}
            className={classNames(styles.inlineControls, { [styles.isVisibleInlineControls]: isVisible })}
        >
            {!firstElement && (
                <li className={styles.control} onClick={() => onClick('up')} title={t('Move up')}>
                    <img src={icon_up} alt="up" />
                </li>
            )}
            {!lastElement && (
                <li className={styles.control} onClick={() => onClick('down')} title={t('Move down')}>
                    <img src={icon_down} alt="down" />
                </li>
            )}
            {!isHideClone && (
                <li className={styles.control} onClick={() => onClick('clone')} title={t('Clone')}>
                    <img src={icon_clone} alt="clone" />
                </li>
            )}
            {!isHideDelete ? (
                <li className={styles.control} onClick={() => onClick('delete')} title={t('Remove')}>
                    <img src={icon_delete} alt="remove" />
                </li>
            ) : (
                <li className={classNames(styles.control, styles.isLockedControl)}>
                    <img src={icon_locked} alt="locked" />
                </li>
            )}
        </ul>
    )
}

export default InlineControls
